/*
 * Redirect Manager
 * ---------------------------------------------------------------------------
 * Client-side redirect engine driven entirely by theme settings.
 *
 * Rules are injected into `window.redirectManagerRules` by an inline <script>
 * in layout/theme.liquid (see Phase 4). This file contains NO hardcoded URLs.
 *
 * Behaviour:
 *   - Rules are evaluated in order. The first match wins, then we stop.
 *   - Empty "from" or "to" fields are silently skipped (no console noise).
 *   - "exact"  : pathname must equal "from" exactly.
 *   - "prefix" : pathname must start with "from"; the remainder of the path
 *                and the original query string are preserved on the target.
 *   - window.location.replace() is used so no extra browser-history entry
 *     is created.
 */
(function () {
  function runRedirects() {
    var rules = window.redirectManagerRules;
    if (!Array.isArray(rules) || rules.length === 0) return;

    var pathname = window.location.pathname;
    var search = window.location.search;

    for (var i = 0; i < rules.length; i++) {
      var rule = rules[i];
      if (!rule) continue;

      var from = typeof rule.from === 'string' ? rule.from.trim() : '';
      var to = typeof rule.to === 'string' ? rule.to.trim() : '';
      var type = rule.type === 'prefix' ? 'prefix' : 'exact';

      // Silent skip when either side is blank.
      if (from === '' || to === '') continue;

      if (type === 'exact') {
        if (pathname === from) {
          window.location.replace(to);
          return;
        }
      } else {
        if (pathname.indexOf(from) === 0) {
          var remainder = pathname.slice(from.length);
          window.location.replace(to + remainder + search);
          return;
        }
      }
    }
  }

  // Fire as early as possible. If the DOM is still parsing, wait for it;
  // otherwise run immediately (script is loaded high in <head>).
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runRedirects);
  } else {
    runRedirects();
  }
})();
